import { Content, Header, HeaderLabel, InfoCard, Page } from '@backstage/core-components';
import ADBForm from './ADBAccessForm';

export const ADBPage = () => {
  return (
    <Page themeId="home">
      <Header title="ADB Elevated Access Form" subtitle="Request Access to manage interactive clusters">
        <HeaderLabel label="Owner" value="Orion Infra Team" />
        <HeaderLabel label="Lifecycle" value="Alpha" />
      </Header>
      <Content>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <InfoCard>
            <ADBForm />
          </InfoCard>
        </div>
      </Content>
    </Page>
  );
};
